export const FULL_ADDRESS = "fullAddress"
export const JOB_CANCELLATION_DATE = "jobCancellationDate"
